"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeature = void 0;
const store_1 = require("../store");
const selectors_1 = require("../store/slices/feature-flags/selectors");
const useFeature = (feature) => {
    return (0, store_1.useSelectorDay1)((0, selectors_1.isFeatureEnabled)(feature));
};
exports.useFeature = useFeature;
//# sourceMappingURL=use-feature.js.map